import React from 'react'
import { FEATURE_NAMES, BENEFIT_NAMES } from 'constants/dataNames'
import Icon from 'elements/Icon'
import * as styles from './ComparePlansOption.scss'

const renderValues = (values, name) => {
  if (name === BENEFIT_NAMES.greatFor) {
    return (
      <ul key={name} className={styles.optionList}>
        {values.map((value, index) => value && (
          <li key={index}>{value}</li>
        ))}
      </ul>
    )
  }
  if (values[0] === false) {
    return null
  }
  return values.map((value, index) => {
    if (value === true) {
      return (
        <span key={index} className={styles.validIcon}>
          <Icon name='valid' size='large' />
        </span>
      )
    }
    if (name === FEATURE_NAMES.modes && values.length > 1 && index === values.length - 1) {
      return (
        <span key={index} className={styles.additionalText}>
          {value}
        </span>
      )
    }
    return values.length > 1 ? `${value}\n` : value
  })
}

const ComparePlansOption = ({ options, name, label }) => (
  <div className={styles.root}>
    <label className={styles.label}>{label}</label>
    <div className={styles.list}>
      {options.filter(x => x.visible).map((planOptions, index) => (
        <div key={index} className={styles.item}
        style={{ width: `${100 / options.filter(x => x.visible).length - 2}%` }}>
          {renderValues(planOptions[name], name)}
        </div>
      ))}
    </div>
  </div>
)

export default ComparePlansOption
